import { IMxrConfig } from '@/interfaces/MxrConfig';
import { CallToActionType } from '@/interfaces/CallToActionTypes';
import { Partner } from '@/interfaces/Partner';
import { Takeover } from '@/takeover';
import { zip } from 'lodash';

/**
 * Returns numbers between 0 and max - 1; max = 3; result = 0 or 1 or 2
 * @param max The max integer a random integer can be but not included
 */
export const getRandomInt: (max: number) => number = (max: number) => Math.floor(Math.random() * Math.floor(max));

export const getQueryStringParamValue = (key: string): string => {
    const url = new URL(window.location.href);
    return url.searchParams.get(key) || '';
};

export const setupRetailerTakeover = (promotion: IMxrConfig, takeover: Takeover): IMxrConfig => {
    const promo = promotion;

    // Have to do this long ass nested loop because of linting rules
    for (let i = 0; i < promo.cards.length; i += 1) {
        for (let x = 0; x < promo.cards[i].shoppingList.length; x += 1) {
            for (let y = 0; y < promo.cards[i].shoppingList[x].items.length; y += 1) {
                const item = promo.cards[i].shoppingList[x].items[y];
                item.id = takeover.IngredientIdItemId.get(item.id) || item.id;
            }
        }
    }

    // TODO: cleanup after retailer cart option is implemented on the console.
    //       footer and tab 3 buttons now depend on integrated retailer & retailerCart ctaType
    promo.footerCallToAction.ctaType = CallToActionType.RETAILER_CART;
    promo.integratedRetailer = promo.integratedRetailer || takeover.Retailer;
    promo.tab3CallToAction.partner = takeover.Retailer;
    promo.footerCallToAction.partner = takeover.Retailer;
    promo.customFooterEnabled = false;
    return promo;
};

export const trimText = (text: string, len: number): string => {
    if (text.length <= len) return text;
    return `${text.trim().substr(0, len).trim()}...`;
};

export const getDeviceType = (windowObj: Window) => {
    if (windowObj.innerWidth >= 1025) {
        return 'desktop';
    } if (windowObj.innerWidth >= 768) {
        return 'tablet';
    }
    return 'mobile';
};

export const queryString = {
    getZipCode(): string {
        const zipCode = getQueryStringParamValue('zipCode');
        return (zipCode && zipCode.length)
            ? zipCode
            : getQueryStringParamValue('zip');
    },
    getZipCodeQueryParam(): string {
        const zipCode = getQueryStringParamValue('zipCode');
        return (zipCode && zipCode.length) ? `?zipCode=${zipCode}` : '';
    },
    getMax(): string {
        let max = getQueryStringParamValue('max');
        if (max && max.length) return max;
        max = getQueryStringParamValue('maximum');
        return (max && max.length)
            ? max
            : getQueryStringParamValue('limit');
    },
    getBeta(): string {
        return getQueryStringParamValue('beta');
    },
};

export default {
    getDeviceType,
    queryString,
};
